import { przezmorzeApi, throwMessageOnBadRequestStatus } from "../../api/api";
import type { ImageDTO } from "../publicRewards/CardImage";

type RewardImage = ImageDTO;

export interface CreateOrUpdateRewardRequest {
  readonly name: string;
  readonly description: string;
  readonly cost: number;
  readonly image?: RewardImage | null;
}

export interface RewardResponse {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly cost: number;
  readonly image?: RewardImage | null;
}

const url = "/loyalty/rewards";

export async function getReward(rewardId: string, abortSignal?: AbortSignal) {
  if (!rewardId) {
    return null;
  }
  const response = await przezmorzeApi.get<RewardResponse>(`${url}/${rewardId}`, {
    signal: abortSignal,
  });
  return response.data;
}

export async function listRewards(abortSignal?: AbortSignal): Promise<RewardResponse[]> {
  const response = await przezmorzeApi.get<{ items: RewardResponse[] }>(url, {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function createReward(
  body: CreateOrUpdateRewardRequest,
  abortSignal?: AbortSignal,
): Promise<RewardResponse> {
  try {
    const response = await przezmorzeApi.post<RewardResponse>(url, body, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnBadRequestStatus(error);
  }
}

export async function updateReward(
  rewardId: string,
  body: CreateOrUpdateRewardRequest,
  abortSignal?: AbortSignal,
): Promise<RewardResponse> {
  try {
    const response = await przezmorzeApi.put<RewardResponse>(`${url}/${rewardId}`, body, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnBadRequestStatus(error);
  }
}

export async function deleteReward(rewardId: string, abortSignal?: AbortSignal): Promise<void> {
  await przezmorzeApi.delete<void>(`${url}/${rewardId}`, {
    signal: abortSignal,
  });
}

export async function buyReward(rewardId: string, abortSignal?: AbortSignal): Promise<void> {
  try {
    await przezmorzeApi.post<RewardResponse>(`${url}/${rewardId}/buy`, {
      signal: abortSignal,
    });
  } catch (error) {
    throwMessageOnBadRequestStatus(error);
  }
}
